var map = {
	"./Android Webview.svg": 872,
	"./Chrome Mobile.svg": 873,
	"./Chrome for Android.svg": 874,
	"./Firefox Mobile.svg": 875,
	"./Google Chrome.svg": 876,
	"./Google Search Mobile.svg": 877,
	"./Microsoft Edge Mobile.svg": 878,
	"./Microsoft Edge.svg": 879,
	"./Opera Mini.svg": 880,
	"./Opera.svg": 881,
	"./Other.svg": 179,
	"./Phoenix Browser.svg": 882,
	"./Safari (in-app).svg": 883,
	"./Safari.svg": 884,
	"./Samsung Internet.svg": 885,
	"./iOS Safari.svg": 886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 871;